import React, { useRef, useState } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-scroll'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import { prepareData } from 'utils/googleData'

const sliderSettings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    autoplay: false,
    variableWidth: true,
}

interface IProps {
    items: {
        name: string
        url: string
        icon?: string
    }[]
    className?: string
    autoScroll?: boolean
    centerMode?: boolean
}

export const AnchorScrollNavbar = (props) => {
    const {
        enable,
        items,
        autoScroll = true,
        className = '',
        centerMode = false,
    } = prepareData({
        props,
    })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    // console.log(`debug items ${JSON.stringify(props)}`)

    const sliderRef = useRef()
    const [activeSliderIndex, setActiveSliderIndex] = useState(0)
    // console.log(`items ${JSON.stringify(items)}`)
    return (
        <div className={className}>
            <div>
                <Slider centerMode={centerMode} ref={sliderRef} {...sliderSettings}>
                    {items &&
                        items.length > 0 &&
                        items?.map(({ name, icon, url }, index) => {
                            const Icon = NotProductIcons[icon] || ProductIcons[icon]
                            return (
                                <div key={name}>
                                    <Link
                                        smooth
                                        duration={300}
                                        offset={-57}
                                        to={url}
                                        hashSpy
                                        className={`hover: rounde d-md relative mr-1 flex cursor-pointer items-center space-x-2 px-3 py-2 text-[14px] font-semibold  text-primary opacity-60 transition-all hover:bg-gray-accent-light hover:opacity-75
                                    active:top-[0.5px]
                                    active:scale-[.98] ${
                                        activeSliderIndex === index ? 'bg-gray-accent-light font-bold opacity-100' : ''
                                    }`}
                                        spy
                                        onClick={() => {
                                            if (autoScroll) {
                                                sliderRef?.current?.slickGoTo(index)
                                            }
                                        }}
                                        onSetActive={() => {
                                            setActiveSliderIndex(index)
                                            if (autoScroll) {
                                                sliderRef?.current?.slickGoTo(index)
                                            }
                                        }}
                                    >
                                        {Icon && <Icon className="mb-4 h-14 w-14 opacity-50" />}
                                        <span>{name}</span>
                                    </Link>
                                </div>
                            )
                        })}
                </Slider>
            </div>
        </div>
    )
}
export default AnchorScrollNavbar
